<registration-region [serviceId]="serviceId">
</registration-region>